import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import TableViewIcon from '@mui/icons-material/TableView';
import {
    Box,
    Button,
    CircularProgress,
    createTheme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';
import { styled } from '@mui/system';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import NewWindow from 'react-new-window';

import ReactComponent from '../ReactComponent';

const temaDialog = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            xl: 1537, // 125% (1536px)
            // @ts-ignore
            xxl: 2559 // 75% (2560px)
        }
    }
});

const DialogImpressao = styled(Dialog)(() => ({
    [temaDialog.breakpoints.between('xs', 'xl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '95%'
            }
        }
    },
    // @ts-ignore
    [temaDialog.breakpoints.between('xl', 'xxl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '75%'
            }
        }
    },
    // @ts-ignore
    [temaDialog.breakpoints.up('xxl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '50%'
            }
        }
    }
}));

class ModalImpressao extends ReactComponent {
    /** @type {string} */
    imprimir = '';

    dataGeracao = new Date();

    constructor(props) {
        super(props);

        makeObservable(this, { dataGeracao: true, render: true,
            imprimir: observable,
            print: action,
            mudarImprimir: action
        });
    }

    print = () => {
        this.imprimir = 'none';
        setTimeout(() => {
            this.mudarImprimir();
        }, 2000);
    };

    mudarImprimir() {
        this.imprimir = '';
    }

    render() {
        return (
            <>
                <DialogImpressao open={this.props.open}>
                    <DialogTitle>{this.props.cabecalho}</DialogTitle>
                    <DialogContent>
                        {this.props.carregando ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                                <CircularProgress
                                    disableShrink={true}
                                    style={{ margin: '10px' }}
                                />
                                <Typography sx={{ color: 'grey', fontStyle: 'italic' }}>
                                    Carregando informações...
                                </Typography>
                            </Box>
                        ) : (
                            this.props.conteudo
                        )}
                    </DialogContent>
                    <div style={{ display: this.imprimir }}>
                        <DialogActions sx={{ mt: 1.5, mb: 1, mr: 2 }}>
                            <Button
                                color="secondary"
                                endIcon={<CancelIcon />}
                                onClick={this.props.onClose}
                                sx={{ mr: 2 }}
                                variant="outlined"
                            >
                                Fechar
                            </Button>
                            {!!this.props.exportar && (
                                <Button
                                    color="primary"
                                    disabled={this.props.carregando}
                                    endIcon={<TableViewIcon />}
                                    onClick={this.props.exportar}
                                    sx={{ mr: 2 }}
                                    variant="outlined"
                                >
                                    Exportar
                                </Button>
                            )}
                            <Button
                                color="primary"
                                disabled={this.props.carregando}
                                endIcon={<PrintIcon />}
                                onClick={this.print}
                                sx={{ ml: 2 }}
                                variant="contained"
                            >
                                Imprimir
                            </Button>
                        </DialogActions>
                    </div>
                </DialogImpressao>
                {this.imprimir === 'none' && (
                    <NewWindow
                        onOpen={(win) =>
                            setTimeout(() => {
                                win.print();
                            }, 1000)
                        }
                        title={this.props.titulo}
                    >
                        {this.props.cabecalho}
                        {this.props.conteudo}
                    </NewWindow>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ModalImpressao));
